module.exports = __webpack_public_path__ + "static/media/1005437.2bb67c25.jpg";